// ReceiverManageModal.jsx 수정본
import React, { useState, useEffect } from 'react';
import { smsReceiverApi } from '../api/smsApi';
// [CONTACT_PICK_V1] 휴대폰 연락처 가져오기
import { canPickContacts, pickContacts, normalizePhone } from '../utils/contactPicker';

export default function ReceiverManageModal({ open, editItem, onClose, onRefresh, groups = [] }) {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    group_name: '',
    category: '고객',
    memo: ''
  });

  // 📍 수정 모드일 때 데이터 채우기
  useEffect(() => {
    if (editItem) {
      setFormData({
        name: editItem.name || '',
        phone: editItem.phone || '',
        group_name: editItem.group_name || '',
        category: editItem.category || '고객',
        memo: editItem.memo || ''
      });
    } else {
      setFormData({ name: '', phone: '', group_name: '', category: '고객', memo: '' });
    }
  }, [editItem, open]);

  // [CONTACT_PICK_V1] 이 기기에서 연락처 가져오기가 가능한지.
  // 안드로이드 Chrome + HTTPS 에서만 true. 그 외에는 버튼 자체를 숨긴다.
  const canPick = canPickContacts();

  // 폰 연락처 창을 띄워 한 명을 골라 입력칸에 채운다.
  // 취소하면 빈 배열이 오므로 아무 일도 일어나지 않는다.
  const handlePickContact = async () => {
    const list = await pickContacts(false);   // false = 한 명만
    if (!list.length) return;
    const c = list[0];
    setFormData(f => ({
      ...f,
      name: c.name || f.name,      // 이름이 비어 있으면 기존 값 유지
      phone: c.phone || f.phone,
    }));
  };

  if (!open) return null;

  const handleSubmit = async () => {
    if (!formData.name || !formData.phone) return alert("이름과 연락처는 필수입니다.");

    // 📍 그룹명 미지정 시 현재 날짜/시간 자동 생성 (YYYY-MM-DD HH:mm)
    let finalGroup = formData.group_name;
    if (!finalGroup || finalGroup.trim() === "") {
      const now = new Date();
      finalGroup = `${now.getFullYear()}-${(now.getMonth()+1).toString().padStart(2,'0')}-${now.getDate().toString().padStart(2,'0')} ${now.getHours().toString().padStart(2,'0')}:${now.getMinutes().toString().padStart(2,'0')}`;
    }

    const payload = { ...formData, group_name: finalGroup };

    try {
      let res;
      if (editItem) {
        res = await smsReceiverApi.update(editItem.id, payload); // 수정 API
      } else {
        res = await smsReceiverApi.create(payload); // 신규 등록 API
      }

      if (res.ok) {
        alert(editItem ? "수정되었습니다." : "등록되었습니다.");
        onRefresh();
        onClose();
      }
    } catch (err) {
      alert("처리 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-header">
          <h3>{editItem ? "📝 수신처 수정" : "➕ 새 수신처 등록"}</h3>
          <button className="close-x" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          <div className="form-grid">
            <div className="form-item">
              <label>성함</label>
              <input value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} placeholder="이름 입력" />
            </div>
            <div className="form-item">
              <label>연락처</label>
              <input value={formData.phone} inputMode="numeric" onChange={e => setFormData({...formData, phone: normalizePhone(e.target.value)})} placeholder="010-1234-5678" /> {/* [PHONE_FMT_V1] 자동 하이픈 */}
            </div>
          </div>

          {/* [CONTACT_PICK_V1] 폰 연락처에서 불러오기.
              안드로이드 Chrome 에서만 버튼이 보인다.
              누르면 폰의 연락처 선택 창이 뜨고, 고른 사람의 이름·번호가 위 칸에 채워진다.
              번호는 utils/contactPicker.js 가 010-1234-5678 형태로 정리해준다. */}
          {canPick && (
            <div style={{ marginBottom: '10px' }}>
              <button
                type="button"
                onClick={handlePickContact}
                style={{
                  width: '100%', padding: '10px',
                  background: '#f0f9ff', color: '#0369a1',
                  border: '1px dashed #7dd3fc', borderRadius: '6px',
                  fontSize: '14px', cursor: 'pointer',
                }}
              >
                📱 폰 연락처에서 불러오기
              </button>
            </div>
          )}

          <div className="form-item">
            <label>그룹 선택/입력 (비우면 현재시간 자동생성)</label>
            <div className="group-input-box">
              <select value={formData.group_name} onChange={e => setFormData({...formData, group_name: e.target.value})}>
                <option value="">-- 직접 입력 또는 선택 --</option>
                {groups.map((g, i) => <option key={i} value={g}>{g}</option>)}
              </select>
              <input value={formData.group_name} onChange={e => setFormData({...formData, group_name: e.target.value})} placeholder="직접 입력" />
            </div>
          </div>

          <div className="form-item">
            <label>구분</label>
            <div className="category-chips">
              {['고객', '직원', '거래처', '기타'].map(cat => (
                <button 
                  key={cat} 
                  className={formData.category === cat ? 'active' : ''} 
                  onClick={() => setFormData({...formData, category: cat})}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          <div className="form-item">
            <label>메모</label>
            <textarea value={formData.memo} onChange={e => setFormData({...formData, memo: e.target.value})} placeholder="상세 메모" rows="2" />
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>취소</button>
          <button className="btn-submit" onClick={handleSubmit}>{editItem ? "수정 완료" : "등록 하기"}</button>
        </div>
      </div>
    </div>
  );
}